module.exports = __webpack_public_path__ + "static/media/apple.4ef34378.png";